import { render } from "./UiDynamischeZahlenReadOnly.pug?vue&type=template&id=e9256c9a&lang=pug"
import script from "./UiDynamischeZahlenReadOnly.js?vue&type=script&lang=js"
export * from "./UiDynamischeZahlenReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__